
import { Request } from "./request";

export interface WarningRuleParams {
    pn?: number;
    ps?: number;
    cautionType?: number;
    nameOrId?: string;
    mainCode?: string;
    mainName?: string
    orgSupervises?: any
    type?: string

}


export function WarningRulePage(body: WarningRuleParams): Request {
    return {
        url: `/api/sys/caution/rule/list`,
        method: "POST",
        body,
    }
}


export function WarningRuleDetail(crId: number): Request {
    return {
        url: `/api/sys/caution/rule/info`,
        method: "GET",
        params: {
            crId
        },
    }
}

